import { render, staticRenderFns } from "./SignObject.vue?vue&type=template&id=1c1675dd&scoped=true&"
import script from "./SignObject.vue?vue&type=script&lang=ts&"
export * from "./SignObject.vue?vue&type=script&lang=ts&"
import style0 from "./SignObject.vue?vue&type=style&index=0&id=1c1675dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1675dd",
  null
  
)

export default component.exports